import { ValidationProject } from '../types/validation';

export const validationProjects: ValidationProject[] = [
  // STAGE 2 FLAGGED PROJECTS (2 - 4%)
  {
    id: 'WS-2024-047',
    name: 'Rio Grande Valley Riparian Restoration',
    type: 'historic',
    category: 'reforestation',
    status: 'stage2',
    stage: 'Stage 2',
    flags: [
      {
        type: 'Benefit Duration Exceeded',
        description: 'Project claims benefit duration of 18 years, exceeding crediting period of 15 years per VWBA 2.0 guidelines',
        field: 'Benefit Duration',
        systemValue: '18 years',
        expectedValue: '≤15 years',
        riskLevel: 'High',
      },
    ],
    details: {
      basin: 'Rio Grande Valley, NM',
      volumetricWaterBenefit: '125,000 m³/year',
      costShare: '65%',
      quantificationMethod: 'Curve Number Method (D-1)',
      previousYear: {
        volumetricWaterBenefit: '120,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-033',
    name: 'Central Valley Agricultural Efficiency Program',
    type: 'historic',
    category: 'efficiency',
    status: 'stage2',
    stage: 'Stage 2',
    flags: [
      {
        type: 'Cost-Share Inconsistency',
        description: 'Cost-share percentage mismatch between system data (75%) and project fact sheet (60%)',
        field: 'Cost-Share',
        systemValue: '75%',
        factSheetValue: '60%',
        riskLevel: 'High',
      },
    ],
    details: {
      basin: 'Central Valley, CA',
      volumetricWaterBenefit: '450,000 m³/year',
      costShare: '75%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
      previousYear: {
        volumetricWaterBenefit: '430,000 m³/year',
        costShare: '60%',
      },
    },
    hasComparison: true,
  },

  {
    id: 'WS-2024-064',
    name: 'Ogallala Aquifer Recharge Initiative',
    type: 'new',
    category: 'infrastructure',
    status: 'stage2',
    stage: 'Stage 2',
    flags: [
      {
        type: 'Quantification Method Review',
        description: 'Project uses non-standard quantification methodology requiring expert validation of groundwater recharge calculations',
        field: 'Quantification Methodology',
        systemValue: 'Custom regional model',
        expectedValue: 'Curve Number Method (D-1), Withdrawal and Consumption Method (D-2), or Inundation Method (D-7)',
        riskLevel: 'High',
      },
    ],
    details: {
      basin: 'Ogallala Aquifer, TX/OK',
      volumetricWaterBenefit: '520,000 m³/year',
      costShare: '70%',
      quantificationMethod: 'Custom Regional Groundwater Model',
    },
  },

  // STAGE 1 FLAGGED PROJECTS (8 - 16%)
  {
    id: 'WS-2024-012',
    name: 'Chesapeake Bay Wetland Enhancement',
    type: 'new',
    category: 'wetland',
    status: 'stage1',
    stage: 'Stage 1',
    flags: [
      {
        type: 'Missing Required Fields',
        description: 'Project missing required baseline water quality data',
        field: 'Baseline Water Quality',
        systemValue: 'Not provided',
        requirement: 'VWBA 2.0 Section 4.2',
      },
    ],
    details: {
      basin: 'Chesapeake Bay, MD',
      volumetricWaterBenefit: '85,000 m³/year',
      costShare: '50%',
      quantificationMethod: 'Inundation Method (D-7)',
    },
  },
  {
    id: 'WS-2024-023',
    name: 'Colorado River Basin Recharge Project',
    type: 'new',
    category: 'infrastructure',
    status: 'stage1',
    stage: 'Stage 1',
    flags: [
      {
        type: 'Missing Required Fields',
        description: 'Stakeholder engagement documentation incomplete',
        field: 'Stakeholder Engagement',
        systemValue: 'Partially documented',
        requirement: 'VWBA 2.0 Section 3.5',
      },
    ],
    details: {
      basin: 'Colorado River Basin, CO',
      volumetricWaterBenefit: '325,000 m³/year',
      costShare: '70%',
      quantificationMethod: 'Curve Number Method (D-1)',
    },
  },
  {
    id: 'WS-2024-038',
    name: 'Great Lakes Urban Runoff Management',
    type: 'historic',
    category: 'infrastructure',
    status: 'stage1',
    stage: 'Stage 1',
    flags: [
      {
        type: 'Requirement Adherence Issue',
        description: 'Project does not meet minimum additionality threshold per VWBA 2.0',
        field: 'Additionality',
        systemValue: '12% improvement',
        requirement: '≥15% improvement (VWBA 2.0 Section 5.1)',
      },
    ],
    details: {
      basin: 'Lake Michigan Basin, MI',
      volumetricWaterBenefit: '95,000 m³/year',
      costShare: '55%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
      previousYear: {
        volumetricWaterBenefit: '90,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-041',
    name: 'Snake River Riparian Buffer Expansion',
    type: 'historic',
    category: 'reforestation',
    status: 'stage2',
    stage: 'Stage 2',
    flags: [
      {
        type: 'System vs Document Inconsistency',
        description: 'Benefit volume differs between system entry and fact sheet',
        field: 'Benefit Volume',
        systemValue: '180,000 m³/year',
        factSheetValue: '175,000 m³/year',
        riskLevel: 'High',
      },
    ],
    details: {
      basin: 'Snake River, ID',
      volumetricWaterBenefit: '180,000 m³/year',
      costShare: '60%',
      quantificationMethod: 'Curve Number Method (D-1)',
      previousYear: {
        volumetricWaterBenefit: '170,000 m³/year',
      },
    },
    hasComparison: true,
  },
  {
    id: 'WS-2024-044',
    name: 'Everglades Restoration Phase III',
    type: 'historic',
    category: 'wetland',
    status: 'stage1',
    stage: 'Stage 1',
    flags: [
      {
        type: 'Material Change vs Previous Year',
        description: 'Benefit volume increased by 45% compared to previous year without adequate justification',
        field: 'Benefit Volume',
        systemValue: '290,000 m³/year',
        previousValue: '200,000 m³/year',
        change: '+45%',
      },
    ],
    details: {
      basin: 'Everglades, FL',
      volumetricWaterBenefit: '290,000 m³/year',
      costShare: '80%',
      quantificationMethod: 'Inundation Method (D-7)',
      previousYear: {
        volumetricWaterBenefit: '200,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-051',
    name: 'Puget Sound Stormwater Retrofit',
    type: 'new',
    category: 'infrastructure',
    status: 'stage1',
    stage: 'Stage 1',
    flags: [
      {
        type: 'Requirement Adherence Issue',
        description: 'Monitoring plan does not meet frequency requirements',
        field: 'Monitoring Plan',
        systemValue: 'Quarterly monitoring',
        requirement: 'Monthly monitoring (VWBA 2.0 Section 6.3)',
      },
    ],
    details: {
      basin: 'Puget Sound, WA',
      volumetricWaterBenefit: '110,000 m³/year',
      costShare: '65%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
    },
  },
  {
    id: 'WS-2024-056',
    name: 'Hudson River Tributary Protection',
    type: 'historic',
    category: 'reforestation',
    status: 'stage2',
    stage: 'Stage 2',
    flags: [
      {
        type: 'System vs Document Inconsistency',
        description: 'Location coordinates mismatch between system and fact sheet',
        field: 'Project Location',
        systemValue: '41.2345°N, 73.9876°W',
        factSheetValue: '41.2354°N, 73.9867°W',
        riskLevel: 'High',
      },
    ],
    details: {
      basin: 'Hudson Valley, NY',
      volumetricWaterBenefit: '75,000 m³/year',
      costShare: '50%',
      quantificationMethod: 'Curve Number Method (D-1)',
      previousYear: {
        volumetricWaterBenefit: '72,000 m³/year',
      },
    },
    hasComparison: true,
  },
  {
    id: 'WS-2024-063',
    name: 'Mississippi Delta Wetland Creation',
    type: 'new',
    category: 'wetland',
    status: 'stage1',
    stage: 'Stage 1',
    flags: [
      {
        type: 'Missing Required Fields',
        description: 'Baseline hydrology and groundwater monitoring data not provided',
        field: 'Baseline Hydrology',
        systemValue: 'Not provided',
        requirement: 'VWBA 2.0 Section 4.7',
      },
    ],
    details: {
      basin: 'Mississippi Delta, LA',
      volumetricWaterBenefit: '380,000 m³/year',
      costShare: '75%',
      quantificationMethod: 'Inundation Method (D-7)',
    },
  },

  // CLEAN PROJECTS (40 - 80%)
  {
    id: 'WS-2024-001',
    name: 'Sierra Nevada Watershed Reforestation',
    type: 'historic',
    category: 'reforestation',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Tulare Lake Basin, CA',
      volumetricWaterBenefit: '250,000 m³/year',
      costShare: '60%',
      quantificationMethod: 'Curve Number Method (D-1)',
      previousYear: {
        volumetricWaterBenefit: '245,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-002',
    name: 'Willamette Valley Wetland Restoration',
    type: 'new',
    category: 'wetland',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Willamette Valley, OR',
      volumetricWaterBenefit: '180,000 m³/year',
      costShare: '55%',
      quantificationMethod: 'Inundation Method (D-7)',
    },
  },
  {
    id: 'WS-2024-003',
    name: 'Texas Panhandle Agricultural Water Conservation',
    type: 'historic',
    category: 'efficiency',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Canadian River Basin, TX',
      volumetricWaterBenefit: '420,000 m³/year',
      costShare: '50%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
      previousYear: {
        volumetricWaterBenefit: '410,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-004',
    name: 'Appalachian Stream Buffer Initiative',
    type: 'new',
    category: 'reforestation',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Ohio River Basin, WV',
      volumetricWaterBenefit: '95,000 m³/year',
      costShare: '65%',
      quantificationMethod: 'Curve Number Method (D-1)',
    },
  },
  {
    id: 'WS-2024-005',
    name: 'Phoenix Metro Reclaimed Water Expansion',
    type: 'historic',
    category: 'infrastructure',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Salt River Basin, AZ',
      volumetricWaterBenefit: '550,000 m³/year',
      costShare: '70%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
      previousYear: {
        volumetricWaterBenefit: '520,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-006',
    name: 'Lake Tahoe Tributary Enhancement',
    type: 'new',
    category: 'reforestation',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Lake Tahoe, CA/NV',
      volumetricWaterBenefit: '140,000 m³/year',
      costShare: '75%',
      quantificationMethod: 'Curve Number Method (D-1)',
    },
  },
  {
    id: 'WS-2024-007',
    name: 'Missouri River Floodplain Restoration',
    type: 'historic',
    category: 'wetland',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Missouri River, MO',
      volumetricWaterBenefit: '310,000 m³/year',
      costShare: '60%',
      quantificationMethod: 'Inundation Method (D-7)',
      previousYear: {
        volumetricWaterBenefit: '305,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-008',
    name: 'Sonoran Desert Rainwater Harvesting',
    type: 'new',
    category: 'infrastructure',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Lower Colorado River Basin, AZ',
      volumetricWaterBenefit: '75,000 m³/year',
      costShare: '50%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
    },
  },
  {
    id: 'WS-2024-009',
    name: 'Platte River Habitat Improvement',
    type: 'historic',
    category: 'reforestation',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Platte River, NE',
      volumetricWaterBenefit: '165,000 m³/year',
      costShare: '55%',
      quantificationMethod: 'Curve Number Method (D-1)',
      previousYear: {
        volumetricWaterBenefit: '160,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-010',
    name: 'San Joaquin Valley Irrigation Modernization',
    type: 'new',
    category: 'efficiency',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'San Joaquin Valley, CA',
      volumetricWaterBenefit: '680,000 m³/year',
      costShare: '65%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
    },
  },
  {
    id: 'WS-2024-011',
    name: 'Yellowstone River Cottonwood Restoration',
    type: 'historic',
    category: 'reforestation',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Yellowstone River, MT',
      volumetricWaterBenefit: '210,000 m³/year',
      costShare: '70%',
      quantificationMethod: 'Curve Number Method (D-1)',
      previousYear: {
        volumetricWaterBenefit: '200,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-013',
    name: 'Cape Cod Aquifer Protection',
    type: 'new',
    category: 'infrastructure',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Cape Cod Aquifer, MA',
      volumetricWaterBenefit: '120,000 m³/year',
      costShare: '60%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
    },
  },
  {
    id: 'WS-2024-014',
    name: 'Sacramento Valley Rice Field Wetlands',
    type: 'historic',
    category: 'wetland',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Sacramento Valley, CA',
      volumetricWaterBenefit: '290,000 m³/year',
      costShare: '55%',
      quantificationMethod: 'Inundation Method (D-7)',
      previousYear: {
        volumetricWaterBenefit: '285,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-015',
    name: 'Boise River Urban Stormwater Management',
    type: 'new',
    category: 'infrastructure',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Boise River Basin, ID',
      volumetricWaterBenefit: '95,000 m³/year',
      costShare: '50%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
    },
  },
  {
    id: 'WS-2024-016',
    name: 'Potomac River Tributary Conservation',
    type: 'historic',
    category: 'reforestation',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Potomac River, VA',
      volumetricWaterBenefit: '135,000 m³/year',
      costShare: '65%',
      quantificationMethod: 'Curve Number Method (D-1)',
      previousYear: {
        volumetricWaterBenefit: '130,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-017',
    name: 'Imperial Valley Precision Irrigation',
    type: 'new',
    category: 'efficiency',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Imperial Valley, CA',
      volumetricWaterBenefit: '520,000 m³/year',
      costShare: '70%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
    },
  },
  {
    id: 'WS-2024-018',
    name: 'Great Salt Lake Marsh Restoration',
    type: 'historic',
    category: 'wetland',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Great Salt Lake, UT',
      volumetricWaterBenefit: '225,000 m³/year',
      costShare: '60%',
      quantificationMethod: 'Inundation Method (D-7)',
      previousYear: {
        volumetricWaterBenefit: '220,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-019',
    name: 'Connecticut River Riparian Corridor',
    type: 'new',
    category: 'reforestation',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Connecticut River, CT',
      volumetricWaterBenefit: '105,000 m³/year',
      costShare: '55%',
      quantificationMethod: 'Curve Number Method (D-1)',
    },
  },
  {
    id: 'WS-2024-020',
    name: 'Denver Metro Green Infrastructure',
    type: 'historic',
    category: 'infrastructure',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'South Platte River Basin, CO',
      volumetricWaterBenefit: '175,000 m³/year',
      costShare: '65%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
      previousYear: {
        volumetricWaterBenefit: '170,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-021',
    name: 'Rogue River Watershed Protection',
    type: 'new',
    category: 'reforestation',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Rogue River, OR',
      volumetricWaterBenefit: '195,000 m³/year',
      costShare: '70%',
      quantificationMethod: 'Curve Number Method (D-1)',
    },
  },
  {
    id: 'WS-2024-022',
    name: 'Arkansas Delta Irrigation Efficiency',
    type: 'historic',
    category: 'efficiency',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Arkansas River Basin, AR',
      volumetricWaterBenefit: '445,000 m³/year',
      costShare: '55%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
      previousYear: {
        volumetricWaterBenefit: '430,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-024',
    name: 'Adirondack Stream Enhancement',
    type: 'new',
    category: 'reforestation',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Upper Hudson River Basin, NY',
      volumetricWaterBenefit: '85,000 m³/year',
      costShare: '60%',
      quantificationMethod: 'Curve Number Method (D-1)',
    },
  },
  {
    id: 'WS-2024-025',
    name: 'Tampa Bay Wetland Conservation',
    type: 'historic',
    category: 'wetland',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Tampa Bay, FL',
      volumetricWaterBenefit: '260,000 m³/year',
      costShare: '65%',
      quantificationMethod: 'Inundation Method (D-7)',
      previousYear: {
        volumetricWaterBenefit: '255,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-026',
    name: 'Tucson Urban Water Harvesting',
    type: 'new',
    category: 'infrastructure',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Santa Cruz River Basin, AZ',
      volumetricWaterBenefit: '110,000 m³/year',
      costShare: '50%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
    },
  },
  {
    id: 'WS-2024-027',
    name: 'Susquehanna River Buffer Restoration',
    type: 'historic',
    category: 'reforestation',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Susquehanna River, PA',
      volumetricWaterBenefit: '155,000 m³/year',
      costShare: '60%',
      quantificationMethod: 'Curve Number Method (D-1)',
      previousYear: {
        volumetricWaterBenefit: '150,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-028',
    name: 'Snake River Plain Aquifer Recharge',
    type: 'new',
    category: 'infrastructure',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Snake River Plain, ID',
      volumetricWaterBenefit: '380,000 m³/year',
      costShare: '70%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
    },
  },
  {
    id: 'WS-2024-029',
    name: 'Klamath River Restoration Initiative',
    type: 'historic',
    category: 'reforestation',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Klamath River, CA/OR',
      volumetricWaterBenefit: '275,000 m³/year',
      costShare: '75%',
      quantificationMethod: 'Curve Number Method (D-1)',
      previousYear: {
        volumetricWaterBenefit: '265,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-030',
    name: 'Central Arizona Canal Lining Project',
    type: 'new',
    category: 'efficiency',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Gila River Basin, AZ',
      volumetricWaterBenefit: '590,000 m³/year',
      costShare: '65%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
    },
  },
  {
    id: 'WS-2024-031',
    name: 'Delaware Bay Salt Marsh Restoration',
    type: 'historic',
    category: 'wetland',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Delaware Bay, DE',
      volumetricWaterBenefit: '195,000 m³/year',
      costShare: '55%',
      quantificationMethod: 'Inundation Method (D-7)',
      previousYear: {
        volumetricWaterBenefit: '190,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-032',
    name: 'Cascade Range Stream Protection',
    type: 'new',
    category: 'reforestation',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Yakima River Basin, WA',
      volumetricWaterBenefit: '165,000 m³/year',
      costShare: '70%',
      quantificationMethod: 'Curve Number Method (D-1)',
    },
  },
  {
    id: 'WS-2024-034',
    name: 'Albuquerque Stormwater Capture',
    type: 'historic',
    category: 'infrastructure',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Middle Rio Grande Basin, NM',
      volumetricWaterBenefit: '125,000 m³/year',
      costShare: '60%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
      previousYear: {
        volumetricWaterBenefit: '120,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-035',
    name: 'Trinity River Urban Wetland Creation',
    type: 'new',
    category: 'wetland',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Trinity River, TX',
      volumetricWaterBenefit: '220,000 m³/year',
      costShare: '65%',
      quantificationMethod: 'Inundation Method (D-7)',
    },
  },
  {
    id: 'WS-2024-036',
    name: 'Catskill Mountains Watershed Protection',
    type: 'historic',
    category: 'reforestation',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Delaware River Basin, NY',
      volumetricWaterBenefit: '145,000 m³/year',
      costShare: '70%',
      quantificationMethod: 'Curve Number Method (D-1)',
      previousYear: {
        volumetricWaterBenefit: '140,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-037',
    name: 'High Plains Irrigation Technology Upgrade',
    type: 'new',
    category: 'efficiency',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'High Plains Aquifer, KS',
      volumetricWaterBenefit: '475,000 m³/year',
      costShare: '55%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
    },
  },
  {
    id: 'WS-2024-039',
    name: 'Lake Champlain Wetland Enhancement',
    type: 'historic',
    category: 'wetland',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Lake Champlain, VT',
      volumetricWaterBenefit: '185,000 m³/year',
      costShare: '60%',
      quantificationMethod: 'Inundation Method (D-7)',
      previousYear: {
        volumetricWaterBenefit: '180,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-040',
    name: 'Santa Fe River Corridor Restoration',
    type: 'new',
    category: 'reforestation',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Santa Fe River, NM',
      volumetricWaterBenefit: '90,000 m³/year',
      costShare: '65%',
      quantificationMethod: 'Curve Number Method (D-1)',
    },
  },
  {
    id: 'WS-2024-042',
    name: 'Portland Metro Rain Garden Network',
    type: 'historic',
    category: 'infrastructure',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Lower Willamette River Basin, OR',
      volumetricWaterBenefit: '135,000 m³/year',
      costShare: '55%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
      previousYear: {
        volumetricWaterBenefit: '130,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-043',
    name: 'Salton Sea Restoration Phase II',
    type: 'new',
    category: 'wetland',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Salton Sea, CA',
      volumetricWaterBenefit: '410,000 m³/year',
      costShare: '80%',
      quantificationMethod: 'Inundation Method (D-7)',
    },
  },
  {
    id: 'WS-2024-045',
    name: 'Pecos River Riparian Enhancement',
    type: 'historic',
    category: 'reforestation',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Pecos River, NM/TX',
      volumetricWaterBenefit: '115,000 m³/year',
      costShare: '60%',
      quantificationMethod: 'Curve Number Method (D-1)',
      previousYear: {
        volumetricWaterBenefit: '110,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-046',
    name: 'Minneapolis-St. Paul Watershed Management',
    type: 'new',
    category: 'infrastructure',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Upper Mississippi River Basin, MN',
      volumetricWaterBenefit: '205,000 m³/year',
      costShare: '70%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
    },
  },
  {
    id: 'WS-2024-048',
    name: 'Spokane River Restoration',
    type: 'historic',
    category: 'reforestation',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Spokane River, WA',
      volumetricWaterBenefit: '160,000 m³/year',
      costShare: '65%',
      quantificationMethod: 'Curve Number Method (D-1)',
      previousYear: {
        volumetricWaterBenefit: '155,000 m³/year',
      },
    },
  },
  {
    id: 'WS-2024-049',
    name: 'Brazos River Basin Conservation',
    type: 'new',
    category: 'efficiency',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'Brazos River, TX',
      volumetricWaterBenefit: '385,000 m³/year',
      costShare: '55%',
      quantificationMethod: 'Withdrawal and Consumption Method (D-2)',
    },
  },
  {
    id: 'WS-2024-050',
    name: 'San Francisco Bay Tidal Marsh Restoration',
    type: 'historic',
    category: 'wetland',
    status: 'clean',
    stage: '-',
    flags: [],
    details: {
      basin: 'San Francisco Bay, CA',
      volumetricWaterBenefit: '340,000 m³/year',
      costShare: '75%',
      quantificationMethod: 'Inundation Method (D-7)',
      previousYear: {
        volumetricWaterBenefit: '330,000 m³/year',
      },
    },
  },
];

// Helper functions for formatting
export const formatStatus = (status: string): string => {
  const statusMap: Record<string, string> = {
    clean: 'Clean',
    stage1: 'Stage 1 Flagged',
    stage2: 'Stage 2 Flagged',
  };
  return statusMap[status] || status;
};

export const formatCategory = (category: string): string => {
  const categoryMap: Record<string, string> = {
    reforestation: 'Reforestation',
    wetland: 'Wetland Restoration',
    efficiency: 'Water Efficiency',
    infrastructure: 'Infrastructure',
  };
  return categoryMap[category] || category;
};
